import { createClient, SupabaseClient } from '@supabase/supabase-js';

// Environment variables must be prefixed with REACT_APP_ to be available in the frontend
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL as string;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Singleton pattern: only one Supabase client instance
const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey);

export default supabase; 